// All action types

const login = {
  REQUEST_LOGIN: 'REQUEST_LOGIN',
  RECEIVE_LOGIN_STATUS: 'RECEIVE_LOGIN_STATUS',
  ERROR_OCURED: 'ERROR_OCURED',
  AUTH_ERRORS: 'AUTH_ERRORS',
  FORET_PASS_ERROR: 'FORET_PASS_ERROR',
  RESET_PASSWORD: 'RESET_PASSWORD',
  SET_SHOULD_RESET: 'SET_SHOULD_RESET',
  LOGIN_STATUS: 'LOGIN_STATUS',
  SET_MAX_LOGIN_ATTEMPT: 'SET_MAX_LOGIN_ATTEMPT',
  RESET_ERROR: 'RESET_ERROR',
}

export default login



// WEBPACK FOOTER //
// src/routes/Login/actions/actionTypes.js